/* TrickStarz Shop v3.1 (Oct 2026): in-page store for /pages/shop. Live products from /products.json, cart via the Shopify AJAX cart API. */
(function () {
  'use strict';
  var root = document.getElementById('tss');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };
  var slugify = function (s) { return norm(s).replace(/\s+/g, '-'); };

  var CATS = [
    { k: 'tees', label: 'Tees', one: 'Tee', long: 'Heavyweight Tees', suffix: 'Heavyweight Tee', type: 'T-Shirt', icon: 'ti-shirt' },
    { k: 'hoodies', label: 'Hoodies', one: 'Hoodie', long: 'Heavyweight Hoodies', suffix: 'Heavyweight Hoodie', type: 'Hoodie', icon: 'ti-hanger' },
    { k: 'prints', label: 'Framed Prints', one: 'Framed Print', long: 'Framed Art Prints', suffix: 'Framed Art Print', type: 'Poster', icon: 'ti-frame' },
    { k: 'mugs', label: 'Mugs', one: 'Mug', long: 'Black Glossy Mugs', suffix: 'Black Glossy Mug', type: 'Mug', icon: 'ti-mug' },
    { k: 'cases', label: 'Phone Cases', one: 'Phone Case', long: 'Magnetic Tough Cases', suffix: 'Magnetic Tough Case', type: 'Phone Case', icon: 'ti-device-mobile' },
    { k: 'stickers', label: 'Stickers', one: 'Sticker', long: 'Kiss-Cut Stickers', suffix: 'Kiss-Cut Sticker', type: 'Paper products', icon: 'ti-sticker' }
  ];
  var MORE = { k: 'more', label: 'More', one: 'Piece', long: 'More From TrickStarz', icon: 'ti-star' };
  var ORDER = ['Star', 'Wave', 'Create', 'Fire', 'Space', 'Time', 'Rose', 'MUSIC', 'High', 'Light', 'Fall', 'Save', 'Moon', 'Dream', 'Sail', 'Wake', 'Soul', 'Ghost', 'Love', 'Sway', 'Locks', 'Ride', 'Wrath', 'Lost', 'Rogue'].map(slugify);
  /* The favorites. The first six rotate at the top of the shop, the next two get spotlights further down. */
  var FAV = ['Star', 'Wave', 'Create', 'Fire', 'Space', 'Time', 'Rose', 'MUSIC', 'High', 'Light', 'Fall', 'Save', 'Moon', 'Dream', 'Sail', 'Wake', 'Soul', 'Ghost'].map(slugify);
  var HERO_N = 6, SPOT_N = 2;
  var SWATCH = { 'black': '#0c0c0f', 'faded black': '#47464c', 'coal': '#34353b', 'white': '#f2f2f2', 'navy': '#1d2340', 'heather grey': '#9a9aa0' };
  var MOTION = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var HAS_IO = 'IntersectionObserver' in window;

  var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  function money(c) {
    var v = (c || 0) / 100;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  }
  function cents(s) { return Math.round(parseFloat(s) * 100) || 0; }
  function img(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function fromPrice(p) { return p.min === p.max ? money(p.min) : '<small>From</small>' + money(p.min); }
  function fromText(p) { return p.min === p.max ? money(p.min) : 'From ' + money(p.min); }
  function catIdx(k) { for (var i = 0; i < CATS.length; i++) if (CATS[i].k === k) return i; return 99; }
  function pIdx(s) { var i = ORDER.indexOf(s); return i < 0 ? 500 : i; }

  var P = [], BYH = {}, PAINT = [], BYS = {};
  var state = { cat: 'all', paint: '', sort: 'featured' };
  var cart = null, qv = null, lastFocus = null, lastFocusCart = null, qvPushed = false, listHash = '#/all';
  var hero = { list: [], i: 0, flip: false }, io = null, heroIO = null;

  /* ---------- Data ---------- */
  function catOf(p) {
    var suf = (p.title.split(' \u00b7 ')[1] || '').trim(), i;
    for (i = 0; i < CATS.length; i++) if (CATS[i].suffix === suf) return CATS[i].k;
    for (i = 0; i < CATS.length; i++) if (CATS[i].type === p.product_type) return CATS[i].k;
    return 'more';
  }
  function songOf(html) {
    var h = String(html || '');
    var t = h.replace(/<[^>]+>/g, ' ').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ');
    var sp = (h.match(/href="(https:\/\/open\.spotify\.com\/[^"]+)"/) || [])[1] || '';
    var m = t.match(/is track (\d+) on the Trick Starz album (.+?) \((\d{4})\)/);
    if (m) return { track: +m[1], album: m[2].trim(), year: m[3], spotify: sp };
    if (/song still in the works/i.test(t)) return { wip: true, spotify: sp };
    return { spotify: sp };
  }
  function build(list) {
    P = list.filter(function (p) { return p && p.variants && p.variants.length && p.images && p.images.length; }).map(function (p) {
      var parts = p.title.split(' \u00b7 ');
      var hasPaint = parts.length > 1;
      var name = (hasPaint ? parts[0] : p.title).trim();
      var variants = p.variants.map(function (v) {
        return { id: v.id, title: v.title, price: cents(v.price), compare: v.compare_at_price ? cents(v.compare_at_price) : 0, available: v.available !== false,
          opts: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }) };
      });
      var prices = variants.map(function (v) { return v.price; });
      var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
      return {
        id: p.id, handle: p.handle, title: p.title, name: name, slug: hasPaint ? slugify(name) : '', cat: catOf(p),
        type: (hasPaint ? parts.slice(1).join(' \u00b7 ') : (p.product_type || '')).trim(),
        images: p.images.map(function (i) { return i.src; }).filter(Boolean),
        options: (p.options || []).map(function (o) { return { name: o.name, values: o.values || [] }; }),
        variants: variants, min: Math.min.apply(null, prices), max: Math.max.apply(null, prices),
        available: variants.some(function (v) { return v.available; }), body: p.body_html || '',
        tags: tags.map(function (s) { return String(s).trim(); }).filter(Boolean), song: songOf(p.body_html)
      };
    });
    BYH = {}; P.forEach(function (p) { BYH[p.handle] = p; });
    var map = {}, keys = [];
    P.forEach(function (p) {
      if (!p.slug) return;
      if (!map[p.slug]) { map[p.slug] = { slug: p.slug, name: p.name, items: [] }; keys.push(p.slug); }
      map[p.slug].items.push(p);
    });
    PAINT = keys.map(function (k) {
      var g = map[k];
      g.items.sort(function (a, b) { return catIdx(a.cat) - catIdx(b.cat); });
      g.byCat = {}; g.items.forEach(function (i) { if (!g.byCat[i.cat]) g.byCat[i.cat] = i; });
      g.chip = (g.byCat.stickers || g.byCat.prints || g.items[0]).images[0];
      g.hero = g.chip;
      g.room = (g.byCat.prints || g.byCat.stickers || g.items[0]).images[0];
      var s = null; g.items.forEach(function (i) { if (!s && (i.song.album || i.song.wip)) s = i.song; });
      g.song = s || g.items[0].song;
      g.min = Math.min.apply(null, g.items.map(function (i) { return i.min; }));
      return g;
    }).sort(function (a, b) { return pIdx(a.slug) - pIdx(b.slug) || a.name.localeCompare(b.name); });
    BYS = {}; PAINT.forEach(function (g) { BYS[g.slug] = g; });
  }
  function activeCats() {
    var out = CATS.filter(function (c) { return P.some(function (p) { return p.cat === c.k; }); });
    if (P.some(function (p) { return p.cat === 'more'; })) out.push(MORE);
    return out;
  }
  function catDef(k) { var a = activeCats(); for (var i = 0; i < a.length; i++) if (a[i].k === k) return a[i]; return null; }
  function favs() {
    var out = [];
    FAV.forEach(function (s) { if (BYS[s] && BYS[s].items.length >= 3) out.push(BYS[s]); });
    return out;
  }
  function setOf(g, n) {
    var out = [];
    ['tees', 'hoodies', 'prints', 'mugs', 'cases', 'stickers', 'more'].forEach(function (c) { if (g.byCat[c] && out.length < n) out.push(g.byCat[c]); });
    return out;
  }
  function typeList(g) {
    var w = g.items.map(function (p) { var c = catDef(p.cat); return (c ? c.one : p.type).toLowerCase(); });
    if (w.length < 2) return w.join('');
    return w.slice(0, -1).join(', ') + ' and ' + w[w.length - 1];
  }

  function sortList(L, how) {
    how = how || state.sort; L = L.slice();
    var feat = function (a, b) { return pIdx(a.slug) - pIdx(b.slug) || a.name.localeCompare(b.name) || catIdx(a.cat) - catIdx(b.cat); };
    if (how === 'low') L.sort(function (a, b) { return a.min - b.min || feat(a, b); });
    else if (how === 'high') L.sort(function (a, b) { return b.max - a.max || feat(a, b); });
    else if (how === 'az') L.sort(function (a, b) { return a.name.localeCompare(b.name) || catIdx(a.cat) - catIdx(b.cat); });
    else L.sort(feat);
    return L;
  }
  function filtered() {
    var L = P;
    if (state.cat !== 'all') L = L.filter(function (p) { return p.cat === state.cat; });
    if (state.paint) L = L.filter(function (p) { return p.slug === state.paint; });
    return sortList(L);
  }

  /* ---------- Pieces of UI ---------- */
  function card(p, k) {
    var a = img(p.images[0], 800), b = p.images[1] ? img(p.images[1], 800) : '';
    var url = '/products/' + encodeURIComponent(p.handle), h = esc(p.handle);
    return '<article class="tss-card' + (b ? ' has-b' : '') + '" style="--i:' + Math.min(k || 0, 9) + '">' +
      '<div class="tss-media"><a href="' + url + '" data-qv="' + h + '" aria-label="' + esc(p.title) + '">' +
      '<img class="a" src="' + a + '" alt="' + esc(p.title) + '" loading="lazy" width="800" height="800">' +
      (b ? '<img class="b" src="' + b + '" alt="" loading="lazy" width="800" height="800">' : '') + '</a>' +
      (p.available ? '' : '<span class="tss-tag">Sold Out</span>') +
      '<button type="button" class="tss-add-q" data-qv="' + h + '" aria-label="Choose options for ' + esc(p.title) + '"><i class="ti ti-plus"></i></button></div>' +
      '<a class="tss-body" href="' + url + '" data-qv="' + h + '"><div><h3 class="tss-name">' + esc(p.name) + '</h3><p class="tss-type">' + esc(p.type) + '</p></div>' +
      '<div class="tss-price">' + fromPrice(p) + '</div></a></article>';
  }
  function sortSel() {
    return '<div class="tss-sort"><select data-sort aria-label="Sort products">' +
      [['featured', 'Featured'], ['low', 'Price: Low To High'], ['high', 'Price: High To Low'], ['az', 'Painting: A To Z']].map(function (o) {
        return '<option value="' + o[0] + '"' + (state.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
      }).join('') + '</select><i class="ti ti-chevron-down"></i></div>';
  }
  function emptyBox() {
    return '<div class="tss-empty"><i class="ti ti-palette"></i><h3>Nothing Here Yet</h3><p>This painting is not made in this product yet.</p>' +
      '<a class="tss-see" href="#/all" data-go="all">Back To The Shop <i class="ti ti-arrow-right"></i></a></div>';
  }
  function songHtml(s, withPill) {
    var out = '';
    if (s && s.track) out += withPill ? '<span class="pill"><i class="ti ti-music"></i>Track ' + s.track + ' \u00b7 ' + esc(s.album) + ' \u00b7 ' + esc(s.year) + '</span>' : '<span>Track ' + s.track + ' \u00b7 ' + esc(s.album) + ' \u00b7 ' + esc(s.year) + '</span>';
    else if (s && s.wip) out += withPill ? '<span class="pill"><i class="ti ti-music"></i>Song In The Works</span>' : '<span>Song In The Works</span>';
    if (s && s.spotify) out += '<a class="tss-spot" href="' + esc(s.spotify) + '" target="_blank" rel="noopener"><i class="ti ti-brand-spotify"></i>Listen On Spotify</a>';
    return out;
  }
  function headHtml(title, extra, id) {
    return '<div class="tss-sec-head rv"' + (id ? ' id="' + id + '"' : '') + '><h2 class="tss-h2">' + title + '</h2>' + (extra || '') + '</div>';
  }

  /* ---------- Home: favorites up top ---------- */
  function heroHtml() {
    var L = hero.list;
    return '<section class="tss-hero" id="tssHero" aria-roledescription="carousel" aria-label="Favorite paintings">' +
      '<div class="tss-hero-bg" aria-hidden="true"><img alt="" class="on"><img alt=""></div>' +
      '<div class="tss-hero-in"><div class="tss-hero-copy" id="tssHeroCopy"></div><div class="tss-bento" id="tssBento"></div></div>' +
      (L.length > 1 ? '<div class="tss-hero-foot"><div class="tss-prog" role="tablist" aria-label="Favorite paintings">' + L.map(function (g, k) {
        return '<button type="button" class="tss-seg" role="tab" data-hi="' + k + '" aria-label="' + esc(g.name) + '"><span class="bar"><span class="fill"></span></span><span class="nm">' + esc(g.name) + '</span></button>';
      }).join('') + '</div><div class="tss-hero-arrows"><button type="button" class="tss-nav" data-hs="-1" aria-label="Previous favorite"><i class="ti ti-chevron-left"></i></button>' +
      '<button type="button" class="tss-nav" data-hs="1" aria-label="Next favorite"><i class="ti ti-chevron-right"></i></button></div></div>' : '') +
      '</section>';
  }
  function drawHero(i, instant) {
    var L = hero.list, el = $('#tssHero');
    if (!L.length || !el) return;
    hero.i = (i + L.length) % L.length;
    var g = L[hero.i], items = setOf(g, 5), song = songHtml(g.song, true);
    var copy = '<span class="tss-kicker"><i class="ti ti-star"></i> Favorites</span>' +
      '<h2 class="tss-hero-name">' + esc(g.name) + '</h2>' +
      (song ? '<div class="tss-pb-song">' + song + '</div>' : '') +
      '<p class="tss-hero-meta">One painting, made into a ' + esc(typeList(g)) + '.</p>' +
      '<div class="tss-hero-cta"><button type="button" class="tss-btn" data-paint="' + g.slug + '">Shop The ' + esc(g.name) + ' Set <i class="ti ti-arrow-right"></i></button>' +
      '<span class="tss-hero-from">' + g.items.length + ' pieces from ' + money(g.min) + '</span></div>';
    var bento = items.map(function (p, k) {
      var c = catDef(p.cat);
      return '<button type="button" class="tss-bt b' + k + '" data-qv="' + esc(p.handle) + '" style="--d:' + k + '">' +
        '<img src="' + img(p.images[0], k ? 560 : 1000) + '" alt="' + esc(p.title) + '" width="' + (k ? 560 : 1000) + '" height="' + (k ? 560 : 1000) + '">' +
        '<span class="tag"><b>' + esc(c ? c.one : p.type) + '</b><span>' + fromText(p) + '</span></span></button>';
    }).join('');
    var apply = function () {
      if (!document.body.contains(el)) return;
      $('#tssHeroCopy').innerHTML = copy;
      $('#tssBento').innerHTML = bento;
      var bgs = $$('.tss-hero-bg img', el), next = bgs[hero.flip ? 0 : 1], cur = bgs[hero.flip ? 1 : 0];
      if (instant && !next.getAttribute('src') && !cur.getAttribute('src')) { cur.src = img(g.hero, 700); }
      else { next.src = img(g.hero, 700); next.classList.add('on'); cur.classList.remove('on'); hero.flip = !hero.flip; }
      $$('.tss-seg', el).forEach(function (s, k) {
        s.classList.toggle('done', k < hero.i);
        s.classList.remove('on');
        s.setAttribute('aria-selected', k === hero.i ? 'true' : 'false');
      });
      var on = $$('.tss-seg', el)[hero.i];
      if (on) { void on.offsetWidth; on.classList.add('on'); }
      el.classList.remove('out');
      el.classList.add('in');
      preload(L[(hero.i + 1) % L.length]);
    };
    if (instant || !MOTION) { el.classList.remove('in'); void el.offsetWidth; apply(); }
    else { el.classList.remove('in'); el.classList.add('out'); window.setTimeout(apply, 260); }
  }
  function preload(g) {
    if (!g || g._pre) return; g._pre = 1;
    setOf(g, 5).forEach(function (p, k) { var im = new Image(); im.src = img(p.images[0], k ? 560 : 1000); });
    var bg = new Image(); bg.src = img(g.hero, 700);
  }
  function statementHtml() {
    var start = MOTION && HAS_IO;
    return '<section class="tss-state rv"><p class="tss-state-big"><b class="cnt" data-n="' + PAINT.length + '" style="min-width:' + String(PAINT.length).length + 'ch">' + (start ? 0 : PAINT.length) + '</b> original paintings, made into <b class="cnt" data-n="' + P.length + '" style="min-width:' + String(P.length).length + 'ch">' + (start ? 0 : P.length) + '</b> pieces.</p>' +
      '<p class="tss-state-sub">' + activeCats().map(function (c) { return esc(c.label); }).join(' \u00b7 ') + '</p></section>';
  }
  function catTilesHtml() {
    var used = {};
    var tiles = activeCats().map(function (c, k) {
      var L = sortList(P.filter(function (p) { return p.cat === c.k; }), 'featured'), pick = null, i;
      for (i = 0; i < L.length; i++) if (!used[L[i].slug]) { pick = L[i]; break; }
      pick = pick || L[0]; used[pick.slug] = 1;
      var min = Math.min.apply(null, L.map(function (p) { return p.min; }));
      return '<button type="button" class="tss-ctile rv" data-cat="' + c.k + '" style="--d:' + k + '"><span class="ph"><img src="' + img(pick.images[0], 800) + '" alt="" loading="lazy" width="800" height="800"></span>' +
        '<span class="cap"><b>' + esc(c.label) + '</b><span>' + L.length + (L.length === 1 ? ' design' : ' designs') + ' \u00b7 from ' + money(min) + '</span></span><span class="go"><i class="ti ti-arrow-up-right"></i></span></button>';
    });
    return '<section class="tss-sec">' + headHtml('Shop By Product') + '<div class="tss-ctiles">' + tiles.join('') + '</div></section>';
  }
  function marqueeHtml() {
    var chip = function (g, dup) {
      return '<button type="button" class="tss-mq-i" data-paint="' + g.slug + '"' + (dup ? ' tabindex="-1" aria-hidden="true"' : '') + '><span class="ring"><span class="in"><img src="' + img(g.chip, 240) + '" alt="" loading="lazy" width="120" height="120"></span></span><span class="nm">' + esc(g.name) + '</span></button>';
    };
    return '<section class="tss-sec tss-mq">' + headHtml('Pick A Painting', '<a class="tss-see" href="#tssPaintings" data-jump="tssPaintings">See All ' + PAINT.length + ' <i class="ti ti-arrow-down"></i></a>') +
      '<div class="tss-mq-track rv"><div class="tss-mq-row">' + PAINT.map(function (g) { return chip(g, false); }).join('') + PAINT.map(function (g) { return chip(g, true); }).join('') + '</div></div></section>';
  }
  function railHtml(c) {
    var L = sortList(P.filter(function (p) { return p.cat === c.k; }), 'featured');
    return '<section class="tss-rail rv" data-rail><div class="tss-rail-head"><h2 class="tss-h2"><span class="lg">' + esc(c.long) + '</span><span class="sm">' + esc(c.label) + '</span><span class="n">' + L.length + '</span></h2>' +
      '<div class="tss-rail-tools"><button type="button" class="tss-nav" data-rs="-1" aria-label="Scroll left"><i class="ti ti-chevron-left"></i></button>' +
      '<button type="button" class="tss-nav" data-rs="1" aria-label="Scroll right"><i class="ti ti-chevron-right"></i></button>' +
      '<a class="tss-see" href="#/' + c.k + '" data-go="' + c.k + '">See All <i class="ti ti-arrow-right"></i></a></div></div>' +
      '<div class="tss-track">' + L.map(card).join('') + '</div></section>';
  }
  function spotHtml(g, k) {
    var items = setOf(g, 4), song = songHtml(g.song, true);
    return '<section class="tss-sband rv' + (k % 2 ? ' flip' : '') + '"><div class="tss-sband-art"><img src="' + img(g.room, 1100) + '" alt="' + esc(g.name) + ' by Ryan A. McNeil" loading="lazy" width="1100" height="1100"></div>' +
      '<div class="tss-sband-info"><span class="tss-kicker"><i class="ti ti-palette"></i> Painting Spotlight</span><h2 class="tss-sband-name">' + esc(g.name) + '</h2>' +
      (song ? '<div class="tss-pb-song">' + song + '</div>' : '') +
      '<div class="tss-sband-set">' + items.map(function (p, j) {
        var c = catDef(p.cat);
        return '<button type="button" data-qv="' + esc(p.handle) + '" style="--d:' + j + '"><img src="' + img(p.images[0], 360) + '" alt="" loading="lazy" width="180" height="180"><span class="t">' + esc(c ? c.one : p.type) + '</span><span class="p">' + fromText(p) + '</span></button>';
      }).join('') + '</div>' +
      '<button type="button" class="tss-btn" data-paint="' + g.slug + '">Shop The ' + esc(g.name) + ' Set <i class="ti ti-arrow-right"></i></button></div></section>';
  }
  function paintTilesHtml() {
    return '<section class="tss-sec">' + headHtml('Shop By Painting<span class="n">' + PAINT.length + '</span>', '', 'tssPaintings') + '<div class="tss-tiles">' +
      PAINT.map(function (g, k) {
        return '<button type="button" class="tss-tile rv" data-paint="' + g.slug + '" style="--d:' + (k % 5) + '"><img src="' + img(g.chip, 520) + '" alt="' + esc(g.name) + '" loading="lazy" width="520" height="520">' +
          '<span class="cap"><b>' + esc(g.name) + '</b><span>' + g.items.length + (g.items.length === 1 ? ' Piece' : ' Pieces') + '</span></span></button>';
      }).join('') + '</div></section>';
  }
  function renderHome(main) {
    var F = favs();
    hero.list = F.slice(0, HERO_N); hero.flip = false;
    if (hero.i >= hero.list.length) hero.i = 0;
    var spots = F.slice(HERO_N, HERO_N + SPOT_N);
    var html = heroHtml() + statementHtml() + catTilesHtml() + marqueeHtml();
    activeCats().forEach(function (c, k) {
      html += railHtml(c);
      if (k === 1 && spots[0]) html += spotHtml(spots[0], 0);
      if (k === 3 && spots[1]) html += spotHtml(spots[1], 1);
    });
    html += paintTilesHtml();
    main.innerHTML = html;
    drawHero(hero.i, true);
    initRails(main);
    observe(main);
    watchHero();
  }

  /* ---------- Painting and category pages ---------- */
  function renderPainting(main) {
    var g = BYS[state.paint];
    if (!g) { state.paint = ''; return render(); }
    var L = g.items, song = songHtml(g.song, true);
    main.innerHTML = '<section class="tss-pb rv"><div class="tss-pb-art"><img src="' + img(g.hero, 1100) + '" alt="' + esc(g.name) + ' by Ryan A. McNeil" width="1100" height="1100"></div>' +
      '<div class="tss-pb-info"><span class="tss-kicker"><i class="ti ti-palette"></i> The Painting</span><h2 class="tss-pb-name">' + esc(g.name) + '</h2>' +
      (song ? '<div class="tss-pb-song">' + song + '</div>' : '') +
      '<p class="tss-pb-meta">' + L.length + (L.length === 1 ? ' piece' : ' pieces') + ' from ' + money(g.min) + '. Collect the set.</p>' +
      '<p class="tss-set-h">The Set</p><div class="tss-set">' + L.map(function (p) {
        return '<button type="button" data-qv="' + esc(p.handle) + '"><img src="' + img(p.images[0], 160) + '" alt="" loading="lazy" width="52" height="52"><span><span class="t">' + esc(p.type) + '</span><span class="p">' + fromText(p) + '</span></span></button>';
      }).join('') + '</div></div></section>' +
      '<div class="tss-line"><h2 class="tss-h2">The ' + esc(g.name) + ' Collection<span class="n">' + L.length + '</span></h2>' + sortSel() + '</div>' +
      '<div class="tss-grid pop">' + sortList(L).map(card).join('') + '</div>';
    observe(main);
  }
  function renderCategory(main) {
    var c = catDef(state.cat);
    if (!c) { state.cat = 'all'; return render(); }
    var L = filtered(), g = state.paint ? BYS[state.paint] : null;
    main.innerHTML = '<div class="tss-line"><div><h2 class="tss-h2">' + esc(c.long) + '<span class="n">' + L.length + '</span></h2>' +
      (g ? '<button type="button" class="tss-chipx" data-clearpaint>' + esc(g.name) + ' only <i class="ti ti-x"></i></button>' : '') + '</div>' + sortSel() + '</div>' +
      (L.length ? '<div class="tss-grid pop">' + L.map(card).join('') + '</div>' : emptyBox());
  }
  function renderCats() {
    var all = [{ k: 'all', label: 'All' }].concat(activeCats());
    $('#tssCats').innerHTML = all.map(function (c) {
      var on = state.cat === c.k && (c.k !== 'all' || !state.paint);
      return '<button type="button" class="tss-cat' + (on ? ' on' : '') + '" data-cat="' + c.k + '" aria-pressed="' + on + '">' + esc(c.label) + '</button>';
    }).join('');
    var on = $('.tss-cat.on'); if (on) keepInView(on, $('#tssCats'));
  }
  function render() {
    renderCats();
    var main = $('#tssMain');
    if (state.cat === 'all' && !state.paint) return renderHome(main);
    if (state.paint && state.cat === 'all') return renderPainting(main);
    return renderCategory(main);
  }
  function skeleton() {
    $('#tssMain').innerHTML = '<div class="tss-sk tss-sk-hero"></div><div class="tss-grid">' + new Array(5).join('<div class="tss-sk"></div>') + '</div>';
  }

  /* ---------- Motion ---------- */
  function countUp(el) {
    $$('.cnt', el).forEach(function (b) {
      var n = +b.getAttribute('data-n') || 0, t0 = null, dur = 1200;
      if (!MOTION || !n) { b.textContent = n; return; }
      var step = function (ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        b.textContent = Math.round(n * e);
        if (k < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    });
  }
  function observe(scope) {
    var els = $$('.rv:not(.in)', scope);
    if (!HAS_IO || !MOTION) { els.forEach(function (e) { e.classList.add('in'); countUp(e); }); return; }
    if (!io) io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); countUp(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  function watchHero() {
    var el = $('#tssHero');
    if (!el || !HAS_IO) return;
    if (heroIO) heroIO.disconnect();
    heroIO = new IntersectionObserver(function (ents) { ents.forEach(function (en) { el.classList.toggle('paused', !en.isIntersecting); }); }, { threshold: 0.2 });
    heroIO.observe(el);
  }

  /* ---------- Scrollers ---------- */
  function keepInView(el, box) {
    if (!el || !box) return;
    var b = box.getBoundingClientRect(), r = el.getBoundingClientRect();
    if (r.left < b.left + 8 || r.right > b.right - 8) box.scrollLeft += (r.left + r.width / 2) - (b.left + b.width / 2);
  }
  function initRails(scope) {
    $$('[data-rail]', scope).forEach(function (r) {
      var t = $('.tss-track', r), btn = $$('.tss-nav', r);
      var upd = function () { btn[0].disabled = t.scrollLeft < 8; btn[1].disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8; };
      t.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }
  function navH() { return parseFloat(root.style.getPropertyValue('--tss-top')) || 0; }
  function toTop() {
    var bar = $('#tssBar'), y = $('#tssMain').getBoundingClientRect().top + window.pageYOffset - navH() - bar.offsetHeight;
    if (window.pageYOffset > y + 4) window.scrollTo({ top: Math.max(0, y), behavior: MOTION ? 'smooth' : 'auto' });
  }
  function jumpTo(id) {
    var t = document.getElementById(id); if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - navH() - $('#tssBar').offsetHeight - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: MOTION ? 'smooth' : 'auto' });
  }
  function setTop() {
    var nav = document.getElementById('tsNav'), h = 0;
    if (nav) { var cs = window.getComputedStyle(nav); if (cs.position === 'sticky' || cs.position === 'fixed') h = nav.getBoundingClientRect().height; }
    root.style.setProperty('--tss-top', Math.round(h) + 'px');
  }

  /* ---------- Routing ---------- */
  function segs() { return decodeURIComponent((location.hash || '').replace(/^#\/?/, '')).split('/').filter(Boolean); }
  function isQVHash() { return /^#\/p\//.test(location.hash); }
  function route() {
    var s = segs();
    if (s[0] === 'p' && s[1] && BYH[s[1]]) { if (!qv || qv.p.handle !== s[1]) openQV(s[1], false); return; }
    if (qv) closeQV(false);
    var before = state.cat + '/' + state.paint, wasHome = !!$('#tssHero');
    var cats = activeCats().map(function (c) { return c.k; });
    if (s[0] && BYS[s[0]] && cats.indexOf(s[0]) < 0) { state.cat = 'all'; state.paint = s[0]; }
    else { state.cat = cats.indexOf(s[0]) > -1 ? s[0] : 'all'; state.paint = s[1] && BYS[s[1]] ? s[1] : ''; }
    if (before === state.cat + '/' + state.paint && wasHome && state.cat === 'all' && !state.paint) { renderCats(); return; }
    render();
    if (before !== state.cat + '/' + state.paint) toTop();
  }
  function go(cat, paint) {
    var h = '#/' + cat + (paint ? '/' + paint : '');
    if (location.hash === h) { route(); toTop(); } else location.hash = h;
  }

  /* ---------- Quick view ---------- */
  function lock(on) { document.documentElement.classList.toggle('tss-lock', !!on); }
  function curV() {
    if (!qv) return null;
    for (var i = 0; i < qv.p.variants.length; i++) {
      var v = qv.p.variants[i], ok = true;
      for (var j = 0; j < v.opts.length; j++) if (v.opts[j] !== qv.sel[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function openQV(handle, push) {
    var p = BYH[handle]; if (!p) return;
    var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    qv = { p: p, sel: v0.opts.slice(), i: 0, qty: 1 };
    if (push !== false) {
      var h = '#/p/' + p.handle;
      if (isQVHash()) history.replaceState({ tss: 1 }, '', h);
      else if (location.hash !== h) { listHash = location.hash || '#/all'; history.pushState({ tss: 1 }, '', h); qvPushed = true; }
    }
    drawQV();
    var m = $('#tssQV');
    if (m.hidden) {
      lastFocus = document.activeElement; m.hidden = false; lock(true);
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { m.classList.add('on'); }); });
    }
    $('#tssQVPanel').scrollTop = 0;
    window.setTimeout(function () { var x = $('#tssQV .tss-x'); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function closeQV(user) {
    if (!qv) return;
    if (user !== false && isQVHash()) {
      if (qvPushed) { qvPushed = false; history.back(); return; }
      history.replaceState(null, '', listHash);
    }
    qv = null; qvPushed = false;
    var m = $('#tssQV'); m.classList.remove('on');
    lock(!$('#tssCart').hidden);
    window.setTimeout(function () { if (!qv) m.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  function drawQV() {
    var p = qv.p, v = curV(), g = BYS[p.slug];
    var imgs = p.images, i = Math.min(qv.i, imgs.length - 1);
    var opts = [], fixed = [];
    p.options.forEach(function (o, oi) { (o.values.length > 1 ? opts : fixed).push({ name: o.name, values: o.values, oi: oi }); });
    var optHtml = opts.map(function (o) {
      var vals = o.values.map(function (val) {
        var match = p.variants.filter(function (x) {
          if (x.opts[o.oi] !== val) return false;
          for (var j = 0; j < x.opts.length; j++) if (j !== o.oi && x.opts[j] !== qv.sel[j]) return false;
          return true;
        });
        var avail = match.some(function (x) { return x.available; }), on = qv.sel[o.oi] === val;
        var sw = /colou?r/i.test(o.name) && SWATCH[String(val).toLowerCase()] ? '<span class="tss-dot" style="background:' + SWATCH[String(val).toLowerCase()] + '"></span>' : '';
        return '<button type="button" class="tss-val' + (on ? ' on' : '') + (avail ? '' : ' x') + '" data-opt="' + o.oi + '" data-val="' + esc(val) + '" aria-pressed="' + on + '">' + sw + esc(val) + '</button>';
      }).join('');
      return '<div class="tss-opt"><div class="tss-opt-h">' + esc(o.name) + ' <b>' + esc(qv.sel[o.oi] || '') + '</b></div><div class="tss-vals" role="group" aria-label="' + esc(o.name) + '">' + vals + '</div></div>';
    }).join('');
    var fixedHtml = fixed.length ? '<p class="tss-fixed">' + fixed.map(function (o) { return esc(o.name) + ': <b>' + esc(o.values[0]) + '</b>'; }).join(' \u00b7 ') + '</p>' : '';
    var song = songHtml(p.song, false);
    var price = v ? money(v.price) : money(p.min), cmp = v && v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '';
    var btn = !v ? 'Unavailable' : !v.available ? 'Sold Out' : '<i class="ti ti-shopping-bag-plus"></i>Add To Cart';
    var others = g ? g.items.filter(function (x) { return x !== p; }) : [];
    $('#tssQVPanel').innerHTML =
      '<div class="tss-gal"><div class="tss-gal-main"><img src="' + img(imgs[i], 1200) + '" alt="' + esc(p.title) + '" width="1200" height="1200">' +
      (imgs.length > 1 ? '<button type="button" class="gnav l" data-gi="-1" aria-label="Previous photo"><i class="ti ti-chevron-left"></i></button><button type="button" class="gnav r" data-gi="1" aria-label="Next photo"><i class="ti ti-chevron-right"></i></button><span class="gcount">' + (i + 1) + ' / ' + imgs.length + '</span>' : '') +
      '</div>' + (imgs.length > 1 ? '<div class="tss-thumbs">' + imgs.map(function (s, k) {
        return '<button type="button" class="' + (k === i ? 'on' : '') + '" data-img="' + k + '" aria-label="Photo ' + (k + 1) + '"><img src="' + img(s, 160) + '" alt="" loading="lazy" width="68" height="68"></button>';
      }).join('') + '</div>' : '') + '</div>' +
      '<div class="tss-info"><p class="tss-qv-type">' + esc(p.type) + '</p><h2 class="tss-qv-name">' + esc(p.name) + '</h2>' +
      (song ? '<div class="tss-qv-song">' + song + '</div>' : '') +
      '<div class="tss-qv-price">' + price + cmp + '</div>' + optHtml + fixedHtml +
      '<div class="tss-buy"><div class="tss-qty"><button type="button" data-qq="-1" aria-label="Less"><i class="ti ti-minus"></i></button><span>' + qv.qty + '</span><button type="button" data-qq="1" aria-label="More"><i class="ti ti-plus"></i></button></div>' +
      '<button type="button" class="tss-add" id="tssAdd"' + (v && v.available ? '' : ' disabled') + '>' + btn + '</button></div>' +
      '<p class="tss-err" id="tssErr" hidden></p>' +
      '<a class="tss-full" href="/products/' + encodeURIComponent(p.handle) + '">View Full Details <i class="ti ti-arrow-right"></i></a>' +
      (others.length ? '<p class="tss-mini-h">More From ' + esc(p.name) + '</p><div class="tss-minis">' + others.map(function (o) {
        return '<button type="button" class="tss-mini" data-qv="' + esc(o.handle) + '"><img src="' + img(o.images[0], 220) + '" alt="" loading="lazy" width="104" height="104"><span class="t">' + esc(o.type) + '</span><span class="p">' + fromText(o) + '</span></button>';
      }).join('') + '</div>' : '') +
      '<div class="tss-desc">' + p.body + '</div></div>';
  }
  function redrawQV(focusSel) {
    var pn = $('#tssQVPanel'), st = pn.scrollTop;
    drawQV(); pn.scrollTop = st;
    if (focusSel) { var f = pn.querySelector(focusSel); if (f) f.focus({ preventScroll: true }); }
  }
  function pick(oi, val) {
    qv.sel[oi] = val;
    if (!curV()) {
      var score = function (x) { var n = 0; for (var j = 0; j < x.opts.length; j++) if (x.opts[j] === qv.sel[j]) n++; return n; };
      var c = qv.p.variants.filter(function (x) { return x.opts[oi] === val; }).sort(function (a, b) { return (b.available - a.available) || (score(b) - score(a)); })[0];
      if (c) qv.sel = c.opts.slice();
    }
    redrawQV('[data-opt="' + oi + '"][data-val="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
  }
  function addToCart() {
    var v = curV(); if (!v || !v.available) return;
    var b = $('#tssAdd'), err = $('#tssErr'), p = qv.p, qty = qv.qty;
    b.disabled = true; b.innerHTML = '<i class="ti ti-loader-2"></i>Adding'; err.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This could not be added to your cart.'); return j; }); })
      .then(function () {
        b.classList.add('ok'); b.innerHTML = '<i class="ti ti-check"></i>Added';
        return loadCart().then(function () { window.setTimeout(function () { if (qv && qv.p === p) closeQV(); toast(p, v); bump(); }, 420); });
      })
      .catch(function (e) { err.textContent = e.message; err.hidden = false; b.disabled = false; b.innerHTML = '<i class="ti ti-shopping-bag-plus"></i>Add To Cart'; });
  }

  /* ---------- Cart ---------- */
  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) { cart = j; })
      .catch(function () { cart = cart || { item_count: 0, items: [], total_price: 0 }; })
      .then(function () { syncCount(); if (!$('#tssCart').hidden) drawCart(); });
  }
  function syncCount() {
    var n = (cart && cart.item_count) || 0;
    Array.prototype.forEach.call(document.querySelectorAll('.ts-nav-cart-count'), function (e) { e.textContent = n; });
    $('#tssCount').textContent = n;
    $('#tssCartBtn').classList.toggle('has', n > 0);
  }
  function bump() { var b = $('#tssCartBtn'); b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
  function openCart() {
    var c = $('#tssCart'), tt = $('#tssToast'); drawCart();
    if (!tt.hidden) { window.clearTimeout(tt._t); tt.classList.remove('on'); tt.hidden = true; }
    if (c.hidden) {
      lastFocusCart = document.activeElement; c.hidden = false; lock(true);
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { c.classList.add('on'); }); });
      window.setTimeout(function () { var x = $('.tss-cart-head .tss-x'); if (x) x.focus({ preventScroll: true }); }, 80);
    }
    loadCart();
  }
  function closeCart() {
    var c = $('#tssCart'); if (c.hidden) return;
    c.classList.remove('on'); lock(!!qv);
    window.setTimeout(function () { c.hidden = true; }, 360);
    if (lastFocusCart && lastFocusCart.focus && document.body.contains(lastFocusCart)) lastFocusCart.focus({ preventScroll: true });
  }
  function drawCart() {
    var items = (cart && cart.items) || [];
    $('#tssCartN').textContent = items.length ? '(' + cart.item_count + ')' : '';
    if (!items.length) {
      $('#tssItems').innerHTML = '<div class="tss-cart-empty"><i class="ti ti-shopping-bag"></i><h4>Your Cart Is Empty</h4><p>Pick a painting and find your piece.</p></div>';
      $('#tssFoot').innerHTML = '<button type="button" class="tss-checkout" data-close>Start Shopping</button>';
      return;
    }
    $('#tssItems').innerHTML = items.map(function (it) {
      return '<div class="tss-ci" data-key="' + esc(it.key) + '"><a class="tss-ci-img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + img(it.image, 200) + '" alt="" width="88" height="88">' : '') + '</a>' +
        '<div><a class="tss-ci-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (it.variant_title ? '<p class="tss-ci-var">' + esc(it.variant_title) + '</p>' : '') +
        '<div class="tss-ci-row"><div class="tss-qty"><button type="button" data-q="-1" aria-label="One less"><i class="ti ti-minus"></i></button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="One more"><i class="ti ti-plus"></i></button></div>' +
        '<span class="tss-ci-price">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price) + '</span></div></div>' +
        '<button type="button" class="tss-ci-rm" data-rm aria-label="Remove ' + esc(it.product_title) + '"><i class="ti ti-trash"></i></button></div>';
    }).join('');
    var disc = (cart.cart_level_discount_applications || []).filter(function (d) { return d.total_allocated_amount > 0; });
    $('#tssFoot').innerHTML = (disc.length ? '<div class="tss-items-row"><span>Items</span><span>' + money(cart.items_subtotal_price) + '</span></div>' +
      disc.map(function (d) { return '<div class="tss-disc-row"><span><i class="ti ti-discount"></i>' + esc(d.title) + '</span><span>-' + money(d.total_allocated_amount) + '</span></div>'; }).join('') : '') +
      '<div class="tss-sub-row"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class="tss-note">Shipping and taxes are calculated at checkout.</p>' +
      '<a class="tss-checkout" href="/checkout"><i class="ti ti-lock"></i>Checkout</a><button type="button" class="tss-keep" data-close>Keep Shopping</button>';
  }
  function changeLine(key, qty) {
    $$('.tss-ci').forEach(function (r) { if (r.getAttribute('data-key') === key) r.classList.add('busy'); });
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .catch(function () {}).then(loadCart).then(drawCart);
  }
  function toast(p, v) {
    var t = $('#tssToast');
    t.innerHTML = '<img src="' + img(p.images[0], 120) + '" alt=""><div class="tx"><b><i class="ti ti-circle-check"></i>Added To Cart</b><span>' + esc(p.name) + ' ' + esc(p.type) +
      (v && v.title && v.title !== 'Default Title' ? ' \u00b7 ' + esc(v.title) : '') + '</span></div><button type="button" data-opencart>View Cart</button>';
    t.hidden = false;
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { t.classList.add('on'); }); });
    window.clearTimeout(t._t);
    t._t = window.setTimeout(function () { t.classList.remove('on'); window.setTimeout(function () { t.hidden = true; }, 320); }, 4200);
  }

  /* ---------- Events ---------- */
  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qv]');
    if (q && root.contains(q)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); openQV(q.getAttribute('data-qv')); return;
    }
    var t = e.target.closest('button, a, [data-close]');
    if (!t || !root.contains(t)) return;
    var d = t.dataset;
    if (d.close != null) { e.preventDefault(); if (t.closest('#tssCart')) closeCart(); else closeQV(); return; }
    if (d.cat != null) { go(d.cat, ''); return; }
    if (d.paint != null) { go('all', d.paint); return; }
    if (d.clearpaint != null) { go(state.cat, ''); return; }
    if (d.go) { e.preventDefault(); go(d.go, ''); return; }
    if (d.jump) { e.preventDefault(); jumpTo(d.jump); return; }
    if (d.hi != null) { drawHero(+d.hi); return; }
    if (d.hs) { drawHero(hero.i + (+d.hs)); return; }
    if (d.rs) { var tr = t.closest('[data-rail]').querySelector('.tss-track'); tr.scrollBy({ left: +d.rs * tr.clientWidth * 0.9, behavior: 'smooth' }); return; }
    if (t.id === 'tssCartBtn' || d.opencart != null) { openCart(); return; }
    if (d.opt != null && qv) { pick(+d.opt, d.val); return; }
    if (d.img != null && qv) { qv.i = +d.img; redrawQV('[data-img="' + d.img + '"]'); return; }
    if (d.gi && qv) { var n = qv.p.images.length; qv.i = (qv.i + (+d.gi) + n) % n; redrawQV('[data-gi="' + d.gi + '"]'); return; }
    if (d.qq && qv) { qv.qty = Math.max(1, Math.min(99, qv.qty + (+d.qq))); var sp = $('#tssQVPanel .tss-buy .tss-qty span'); if (sp) sp.textContent = qv.qty; return; }
    if (t.id === 'tssAdd') { addToCart(); return; }
    if (d.q && cart) {
      var key = t.closest('.tss-ci').getAttribute('data-key');
      var it = cart.items.filter(function (x) { return x.key === key; })[0];
      if (it) changeLine(key, Math.max(0, it.quantity + (+d.q)));
      return;
    }
    if (d.rm != null) { changeLine(t.closest('.tss-ci').getAttribute('data-key'), 0); return; }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) { state.sort = e.target.value; render(); }
  });
  root.addEventListener('animationend', function (e) {
    if (e.animationName === 'tssFill' && e.target.closest('.tss-seg.on')) drawHero(hero.i + 1);
  });
  var sx = null, sy = 0, sw = '';
  root.addEventListener('touchstart', function (e) {
    var inQV = qv && e.target.closest('.tss-gal-main'), inHero = !qv && e.target.closest('#tssHero');
    if (inQV || inHero) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; sw = inQV ? 'qv' : 'hero'; } else sx = null;
  }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (sx == null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
    if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
    if (sw === 'qv' && qv) { var n = qv.p.images.length; if (n > 1) { qv.i = (qv.i + (dx < 0 ? 1 : -1) + n) % n; redrawQV(); } }
    else if (sw === 'hero') drawHero(hero.i + (dx < 0 ? 1 : -1));
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (!$('#tssCart').hidden) closeCart(); else if (qv) closeQV(); return; }
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.closest && e.target.closest('.tss-prog')) {
      e.preventDefault(); drawHero(hero.i + (e.key === 'ArrowRight' ? 1 : -1));
      var s = $$('.tss-seg')[hero.i]; if (s) s.focus();
    }
  });
  Array.prototype.forEach.call(document.querySelectorAll('a.ts-nav-cart'), function (a) {
    a.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); openCart(); });
  });

  /* ---------- Start ---------- */
  function fetchProducts() {
    var all = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) { var list = j.products || []; all = all.concat(list); return list.length === 250 && n < 8 ? page(n + 1) : all; });
    }
    return page(1);
  }
  setTop();
  window.addEventListener('resize', setTop);
  skeleton();
  loadCart();
  fetchProducts().then(function (list) {
    build(list);
    if (!P.length) throw new Error('empty');
    window.addEventListener('hashchange', route);
    route();
  }).catch(function () {
    $('#tssMain').innerHTML = '<div class="tss-empty"><i class="ti ti-refresh"></i><h3>The Shop Did Not Load</h3><p>Refresh the page, or see every product on one page.</p><a class="tss-see" href="/collections/all">See All Products <i class="ti ti-arrow-right"></i></a></div>';
  });
})();
